<template>
  <div class="patient-form-container" :class="modalTheme">
    <!-- Add the load button at the top -->
    <!-- <div class="form-actions-top">
      <button :disabled="!patientStore.currentPatient.lastName" type="button" class="btn btn-info" @click="loadFromPatientStore">Load Current Patient from Store</button>
      <button type="button" class="btn btn-secondary" @click="loadFromProps">Load from Props</button>
      <button type="button" class="btn btn-secondary" @click="loadSampleData">Load Sample Data</button>
      <span v-if="patientStore.currentPatient.lastName" class="current-patient-info"> Current: {{ patientStore.currentPatient.firstName }} {{ patientStore.currentPatient.lastName }} </span>
      <span v-else class="no-patient-info"> No current patient selected </span>
    </div> -->

    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" :class="modalTheme">
      <b-row>
        <b-col cols="12" md="6">
          <div class="form-section" :class="userStore.borderClass">
            <h3 style="text-align: left">Contact Name</h3>

            <b-form-group label="First Name:" label-for="contactFirstName" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="contactFirstName" v-model="form.contactFirstName" size="sm" :class="modalTheme" />
            </b-form-group>

            <b-form-group label="Middle Name:" label-for="contactMiddleName" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="contactMiddleName" v-model="form.contactMiddleName" size="sm" :class="modalTheme" />
            </b-form-group>

            <b-form-group label="Last Name:" label-for="contactLastName" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="contactLastName" v-model="form.contactLastName" size="sm" :class="modalTheme" />
            </b-form-group>

            <b-form-group label="Maiden Name:" label-for="contactMaidenName" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="contactMaidenName" v-model="form.contactMaidenName" size="sm" :class="modalTheme" />
            </b-form-group>

            <b-form-group label="Emergency Contact:" label-for="IsEmergencyContact" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-checkbox id="IsEmergencyContact" v-model="form.IsEmergencyContact" size="sm" switch :class="modalTheme" />
            </b-form-group>

            <b-form-group label="Healthcare Proxy:" label-for="IsHealthCareProxy" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-checkbox id="IsHealthCareProxy" v-model="form.IsHealthCareProxy" size="sm" switch :class="modalTheme"> Can make health decisions on behalf of patient </b-form-checkbox>
            </b-form-group>

            <b-form-group label="Primary Caregiver:" label-for="HasHomeCaregiver" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-checkbox id="HasHomeCaregiver" v-model="form.HasHomeCaregiver" size="sm" switch :class="modalTheme"> Primary Caregiver at Home </b-form-checkbox>
            </b-form-group>
          </div>
        </b-col>
        <b-col cols="12" md="6">
          <div class="form-section" :class="userStore.borderClass">
            <h3 style="text-align: left">Notes</h3>

            <b-form-group label="Notes:" label-for="contactNotes" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-textarea id="contactNotes" v-model="form.contactNotes" size="sm" placeholder="Additional notes about contact" rows="3" max-rows="5" :class="modalTheme" />
            </b-form-group>
          </div>
        </b-col>
      </b-row>

      <div class="form-section" :class="userStore.borderClass">
        <h3 style="text-align: left">Relationship</h3>

        <b-form-group label="Relationship:" label-for="contactRelationship" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-radio-group
            id="contactRelationship"
            v-model="form.contactRelationship"
            :options="[
              { text: 'Spouse', value: 1 },
              { text: 'Parent', value: 2 },
              { text: 'Child', value: 3 },
              { text: 'Sibling', value: 4 },
              { text: 'Grandparent', value: 5 },
              { text: 'Grandchild', value: 6 },
              { text: 'Friend', value: 7 },
              { text: 'Caregiver', value: 8 },
              { text: 'Other', value: 9 },
            ]"
            buttons
            button-variant="outline-secondary"
            size="sm"
            :class="modalTheme"
          />
        </b-form-group>
      </div>

      <b-row>
        <b-col cols="12">
          <div class="form-section" :class="userStore.borderClass">
            <h3 style="text-align: left">Address</h3>

            <b-form-group label="Address 1:" label-for="contactAddress1" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-0">
              <b-form-input id="contactAddress1" v-model="form.contactAddress1" size="sm" placeholder="Street address" :class="modalTheme" />
            </b-form-group>

            <b-form-group label="Address 2:" label-for="contactAddress2" label-cols="3" label-size="sm" label-align="right" label-class="form-label-align" class="mb-2">
              <b-form-input id="contactAddress2" v-model="form.contactAddress2" size="sm" placeholder="Apt, suite, etc." :class="modalTheme" />
            </b-form-group>

            <!-- City/State row aligned with Address 1/2 -->
            <b-form-group class="mb-0" label-cols="1" label-class="form-label-align">
              <b-row no-gutters>
                <b-col cols="6" class="pr-1">
                  <b-form-group label="City:" label-for="contactCity" label-cols="4" label-align="right" label-size="sm" label-class="form-label-align" class="mb-0">
                    <b-form-input id="contactCity" v-model="form.contactCity" size="sm" placeholder="Enter city" :class="modalTheme" />
                  </b-form-group>
                </b-col>
                <b-col cols="6" class="pl-1">
                  <b-form-group label="State:" label-for="contactState" label-cols="4" label-align="right" label-size="sm" label-class="form-label-align" class="mb-0">
                    <b-form-input id="contactState" v-model="form.contactState" size="sm" placeholder="Enter state" :class="modalTheme" />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form-group>

            <b-form-group class="mb-0" label-cols="1" label-class="form-label-align">
              <b-row no-gutters>
                <b-col cols="6" class="pr-1">
                  <b-form-group label="County:" label-for="contactCounty" label-cols="4" label-align="right" label-size="sm" label-class="form-label-align" class="mb-0">
                    <b-form-input id="contactCounty" v-model="form.contactCounty" size="sm" placeholder="Enter county" :class="modalTheme" />
                  </b-form-group>
                </b-col>
                <b-col cols="6" class="pl-1">
                  <b-form-group label="Zip Code:" label-for="contactZipCode" label-cols="4" label-align="right" label-size="sm" label-class="form-label-align" class="mb-0">
                    <b-form-input id="contactZipCode" v-model="form.contactZipCode" size="sm" placeholder="12345" :class="modalTheme" />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form-group>
            <b-form-group label="Telephone:" label-for="contactTelephoneNumber" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="contactTelephoneNumber" :class="modalTheme" v-model="form.contactTelephoneNumber" type="tel" size="sm" v-mask="'(###) ###-####'" placeholder="(555) 123-4567" />
            </b-form-group>

            <b-form-group label="Mobile:" label-for="contactMobileNumber" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="contactMobileNumber" :class="modalTheme" v-model="form.contactMobileNumber" type="tel" size="sm" v-mask="'(###) ###-####'" placeholder="(555) 123-4567" />
            </b-form-group>

            <b-form-group label="Fax Number:" label-for="contactFaxNumber" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="contactFaxNumber" :class="modalTheme" v-model="form.contactFaxNumber" type="tel" size="sm" v-mask="'(###) ###-####'" placeholder="(555) 123-4567" />
            </b-form-group>

            <b-form-group label="Pager Number:" label-for="contactPagerNumber" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="contactPagerNumber" :class="modalTheme" v-model="form.contactPagerNumber" type="tel" size="sm" v-mask="'(###) ###-####'" placeholder="(555) 123-4567" />
            </b-form-group>

            <b-form-group label="Email:" label-for="contactEmailAdress" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="contactEmailAdress" :class="modalTheme" v-model="form.contactEmailAdress" type="email" size="sm" placeholder="email@example.com" />
            </b-form-group>
          </div>
        </b-col>
      </b-row>

      <hr />
      <div class="form-actions">
        <b-button type="reset" variant="secondary">Reset</b-button>
        <b-button type="submit" variant="primary">Save Contact</b-button>
      </div>
      <pre>{{ form }}</pre>
    </b-form>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import moment from "moment";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
// * STORE
import { usePatientStore } from "@/stores/patientStore";
const patientStore = usePatientStore();

const modalTheme = computed(() => userStore.bModalTheme);

// Emits
const emit = defineEmits(["save-patient", "reset-form"]);

// & PROPS
const props = defineProps({
  testPatient: {
    Type: Object,
    Default: () => {},
  },
});

// Create form factory function
function createForm() {
  return {
    contactFirstName: "",
    contactMiddleName: "",
    contactLastName: "",
    contactMaidenName: "",

    IsEmergencyContact: true,
    IsHealthCareProxy: false,
    HasHomeCaregiver: false,

    contactNotes: "",
    contactRelationship: 0,

    contactAddress1: "",
    contactAddress2: "",
    contactCity: "",
    contactCounty: "",
    contactZipCode: "",
    contactCounty: "",
    contactState: "",
    contactTelephoneNumber: "",
    contactMobileNumber: "",
    contactFaxNumber: "",
    contactPagerNumber: "",
    contactEmailAdress: "",
  };
}

// Form state
const form = ref(createForm());
const AreIdsShown = ref(true);

// Form validation
const isFormValid = () => {
  if (!form.value.firstName.trim()) {
    alert("First name is required");
    return false;
  }
  if (!form.value.lastName.trim()) {
    alert("Last name is required");
    return false;
  }
  if (!form.value.patientID.trim()) {
    alert("Patient ID is required");
    return false;
  }
  return true;
};

// Form handlers
function onSubmit() {
  if (!isFormValid()) {
    return;
  }

  const payload = {
    ...form.value,
    // Convert date strings to proper formats if needed
    chartReviewDate: form.value.chartReviewDate ? new Date(form.value.chartReviewDate).toISOString() : null,
    startDate: form.value.startDate ? new Date(form.value.startDate).toISOString() : null,
    endDate: form.value.endDate ? new Date(form.value.endDate).toISOString() : null,
    nextAppointment: form.value.nextAppointment ? new Date(form.value.nextAppointment).toISOString() : null,
    serviceDate: form.value.serviceDate ? moment(form.value.serviceDate).format("MM/DD/YYYY") : "",
  };

  emit("save-patient", payload);
  console.log("Saving patient:", payload);
}

function onReset() {
  form.value = createForm();
  emit("reset-form");
}

// Load initial data (example with the provided values)
function loadSampleData() {
  form.value = {
    personID: 14526,
    firstName: "Sample",
    middleName: "M",
    lastName: "DATA",
    dateOfBirth: "1971-09-16",
    patientID: "2405061",
    memberID: "N/A",
    insuranceCarrier: "UNKNOWN",
    dob: "19710916",
    gender: "F",
    providerName: "Grizzle, Melissa",
    serviceDate: "2022-12-14",
    lastSeenByMe: "Grizzle, Melissa",
    chartReviewDate: moment("0001-01-01T00:00:00Z").isValid() ? moment("0001-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
    chartReviewBy: null,
    chartReviewNeeded: true,
    chartReviewComment: null,
    chartReviewRole: null,
    emrId: null,
    startDate: moment("1900-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm"),
    nextAppointmentWith: "",
    nextAppointmentReason: "",
    nextAppointmentType: "",
    nextAppointmentComment: "",
    patientStatus: true,
    endDate: moment("1900-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm"),
    appointmentLocation: null,
    isScheduled: false,
    nextAppointment: moment("1900-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm"),
  };
}
function loadFromProps() {
  if (props.testPatient && typeof props.testPatient === "object") {
    form.value = {
      ...createForm(),
      ...props.testPatient,
      chartReviewDate: props.testPatient.chartReviewDate ? moment(props.testPatient.chartReviewDate).format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
      startDate: props.testPatient.startDate ? moment(props.testPatient.startDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      endDate: props.testPatient.endDate ? moment(props.testPatient.endDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      nextAppointment: props.testPatient.nextAppointment ? moment(props.testPatient.nextAppointment).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
    };
  }
}

// New method to bind from store object to form
function loadFromPatientStore() {
  const currentPatient = patientStore.currentPatient;
  if (currentPatient && typeof currentPatient === "object") {
    form.value = {
      ...createForm(),
      ...currentPatient,
      // Handle date conversions
      dateOfBirth: currentPatient.dateOfBirth ? moment(currentPatient.dateOfBirth).format("YYYY-MM-DD") : "",
      serviceDate: currentPatient.serviceDate ? moment(currentPatient.serviceDate).format("YYYY-MM-DD") : "",
      chartReviewDate: currentPatient.chartReviewDate ? moment(currentPatient.chartReviewDate).format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
      startDate: currentPatient.startDate ? moment(currentPatient.startDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      endDate: currentPatient.endDate ? moment(currentPatient.endDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      nextAppointment: currentPatient.nextAppointment ? moment(currentPatient.nextAppointment).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
    };
    console.log("Loaded patient from store:", currentPatient);
  } else {
    console.warn("No current patient found in store");
    alert("No current patient available in store");
  }
}

onMounted(() => {
  // console.log("onMounted() : Patient Form >>>>");
  // console.log("props : testPatient ");
  // console.log(props.testPatient);
  // loadSampleData();
  // loadFromProps();
  // loadFromPatientStore();
});
</script>

<style scoped>
.patient-form-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  height: 65vh;
  overflow: hidden;
  overflow-y: auto;
}

.form-section {
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  text-align: center;
}

.form-section h3 {
  color: #495057;
  margin-bottom: 15px;
  font-size: 1.2em;
  border-bottom: 2px solid #007bff;
  padding-bottom: 5px;
  text-align: center;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px 0;
  border-top: 1px solid #dee2e6;
  margin-top: 20px;
}

hr {
  border: none;
  height: 1px;
  background-color: #0d85fd;
  margin: 20px 0;
}

/* Bootstrap Vue form group label alignment */
.b-form-group .col-form-label {
  font-size: 15px !important;
  font-weight: 600;
  text-align: right !important;
  justify-content: flex-end !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  white-space: nowrap;
}

/* Remove Bootstrap Vue form group internal spacing */
.b-form-group {
  margin-bottom: 0.5rem !important;
}

.b-form-group .row {
  margin: 0 !important;
}

.b-form-group .row > [class*="col"] {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

/* 10px gap between label and input columns */
.form-section .b-form-group .row > [class*="col"]:first-child {
  padding-right: 10px !important;
  padding-left: 0 !important;
}

.form-section .b-form-group .row > [class*="col"]:not(:first-child) {
  padding-left: 0 !important;
  padding-right: 5px !important;
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
  }

  .form-group {
    min-width: unset;
  }
}

/* Top form actions styles (currently commented out)
.form-actions-top {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px 0;
  margin-bottom: 20px;
  border-bottom: 1px solid #dee2e6;
}

.current-patient-info {
  color: #28a745;
  font-weight: 600;
  font-size: 14px;
}

.no-patient-info {
  color: #dc3545;
  font-style: italic;
  font-size: 14px;
}
*/

.radio-group {
  flex-direction: column;
  align-items: flex-start;
}

.radio-group > label {
  min-width: auto;
  margin-bottom: 10px;
  font-weight: 600;
}

.radio-options {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-top: 10px;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: normal;
  cursor: pointer;
  min-width: auto;
  margin-bottom: 0;
  text-align: left;
}

.radio-label input[type="radio"] {
  margin: 0;
  width: 16px;
  height: 16px;
}

/* Add/override for city/state row alignment */
.form-section .b-form-group .row.no-gutters {
  margin-left: 0 !important;
  margin-right: 0 !important;
  gap: 0 !important;
}

.form-section .b-form-group .row.no-gutters > [class*="col"] {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* Reduce gap between city and state columns */
.form-section .b-form-group .row.no-gutters > .pr-1 {
  padding-right: 4px !important;
}

.form-section .b-form-group .row.no-gutters > .pl-1 {
  padding-left: 4px !important;
}
</style>
